import React from 'react';
import { strings } from '../../../resources/strings';
import { Field, FieldType } from '../../../common-components/Field/Field';

export class FormOrderNoteValues {
    value?: string;
}

interface IFormOrderNoteProps {
    values?: FormOrderNoteValues;
    change: (values: FormOrderNoteValues) => void;
    notLabel?: boolean;
}

const FormOrderNote: React.FC<IFormOrderNoteProps> = ({
    values,
    change,
    notLabel
}) => {

    return (
        <>
            <Field 
                label={notLabel ? '' : strings.NewNote}
                type={FieldType.TextArea}
                value={values?.value}
                change={(value) => changeValues({...(values||{}), value: value})}
                marginTop='0px'
                autoFocus
            />
        </>
    );

    function changeValues(values: FormOrderNoteValues) {
        change({...values});
    }
}

export {FormOrderNote};